"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileBrowserDisplay = void 0;
const React = __importStar(require("react"));
const resources_1 = require("../model/resources");
const path_1 = require("../model/path");
const file_table_1 = require("./file-table");
const portal_context_menu_1 = require("./portal-context-menu");
const react_contextmenu_1 = require("react-contextmenu");
const react_bootstrap_1 = require("react-bootstrap");
const upload_media_component_1 = __importDefault(require("./upload-media-component"));
const action_toolbar_1 = require("./action-toolbar");
const tableBodyContextMenuId = "table-body-context-menu";
const maxFolderDepth = 7;
class FileBrowserDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.rowHeight = 47;
        this.state = {
            CreatingNewFolder: undefined,
            ClipboardResources: null,
            CutResource: false
        };
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    handleKeyPress(event) {
        const copyResourceToClipboard = () => {
            if (this.props.SelectedResources) {
                this.setState({
                    ClipboardResources: this.props.SelectedResources,
                    CutResource: false
                });
            }
        };
        const cutResource = () => {
            if (this.props.SelectedResources) {
                this.setState({
                    ClipboardResources: this.props.SelectedResources,
                    CutResource: true
                });
            }
        };
        const pasteResources = () => {
            const folder = resources_1.FolderOf(this.props.Current);
            if (folder && this.state.ClipboardResources) {
                if (!this.state.CutResource) {
                    if (folder.InsertCopy != null) {
                        folder.InsertCopy(this.state.ClipboardResources).then(() => {
                            this.props.Open(folder);
                        });
                    }
                }
                else {
                    if (folder.Move != null) {
                        folder.Move(this.state.ClipboardResources).then(() => {
                            this.props.Open(folder);
                        });
                    }
                }
            }
        };
        const keyEvents = [
            { Key: "c", Ctrl: true, Action: copyResourceToClipboard },
            { Key: "x", Ctrl: true, Action: cutResource },
            { Key: "v", Ctrl: true, Action: pasteResources }
        ];
        const keyboardEvent = event;
        this.processKeyEvents(keyEvents, keyboardEvent);
    }
    processKeyEvents(keyEvents, keyboardEvent) {
        keyEvents.forEach(event => {
            if (keyboardEvent.ctrlKey === event.Ctrl) {
                if (keyboardEvent.key === event.Key) {
                    event.Action();
                }
            }
        });
    }
    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }
    render() {
        const reload = () => {
            this.setState({ PendingRenameResource: undefined });
            if (this.props.Current) {
                this.props.Open(this.props.Current);
            }
            else {
                throw new Error("Reload isn't yet implemented for display with no location");
            }
        };
        const createNewFolder = () => __awaiter(this, void 0, void 0, function* () {
            const newFolderName = "New Folder";
            const folder = resources_1.FolderOf(this.props.Current);
            const pathChildren = yield folder.GetChildren();
            const numOfNewFolders = pathChildren === null || pathChildren === void 0 ? void 0 : pathChildren.filter(child => child.Type === resources_1.ResourceTypes.Folder && child.Path.Name.startsWith("New Folder")).length;
            const numNamePart = (numOfNewFolders && numOfNewFolders >= 1) ? `(${numOfNewFolders})` : "";
            const newFolderPath = folder.Path.Concat(`${newFolderName} ${numNamePart}`);
            const error = this.getNewFolderError(newFolderPath.Name);
            if (error) {
                this.props.RaiseAlert(error);
                return null;
            }
            if (this.props.CreateFolder) {
                const folder = yield this.props.CreateFolder(newFolderPath);
                reload();
                this.setState(s => (Object.assign(Object.assign({}, s), { PendingRenameResource: folder })));
                return folder;
            }
            return null;
        });
        const topSpaceTakenUp = this.props.ShowHorizontalToolbar ? 2 * this.rowHeight : this.rowHeight;
        const current = this.props.Current;
        if (current) {
            // Only a folder can have things created, uploaded or pasted into it
            const folder = resources_1.FolderOf(current);
            const table = React.createElement(file_table_1.FileTable, { style: { minWidth: "100%", maxHeight: `calc(100% - ${folder ? topSpaceTakenUp : this.rowHeight}px)` }, Items: this.props.Resources, Context: this.props.Context, Reload: reload, OnSelectionChanged: selected => this.props.SelectResources(selected, "Tentative"), OpenFolder: opened => this.props.Open(opened), Submit: resource => this.props.SelectResources([resource], "Emphatic"), PromptForFolder: this.props.PromptForFolder, RaiseAlert: this.props.RaiseAlert, CreateNewFolder: folder ? createNewFolder : () => __awaiter(this, void 0, void 0, function* () { return null; }), PendingRenameResource: this.state.PendingRenameResource, CancelRename: () => { this.setState({ PendingRenameResource: undefined }); } });
            return React.createElement("div", { style: { height: "100%" }, className: "flex-grow-1" },
                folder && this.props.ShowHorizontalToolbar && React.createElement(action_toolbar_1.HorizontalToolbar, { height: this.rowHeight, actions: [
                        this.props.ShowUploadOption
                            ? React.createElement(upload_media_component_1.default, { UploadFile: this.props.UploadFile, RaiseInfo: this.props.RaiseInfo, RaiseAlert: this.props.RaiseAlert, ShowIcon: true })
                            : React.createElement("div", null),
                        {
                            name: "New Folder",
                            icon: file_table_1.FileItemContextMenuItemTemplates.NewFolder.Icon,
                            action: () => createNewFolder()
                        }
                    ] }),
                React.createElement("div", { className: "file-browser-breadcrumbs-container", style: { height: `${this.rowHeight}px` } },
                    [...this.renderBreadCrumb(current)],
                    React.createElement("div", { style: { flexGrow: 1 } })),
                React.createElement(react_contextmenu_1.ContextMenuTrigger, { id: tableBodyContextMenuId, holdToDisplay: 5000, disable: !folder, attributes: { style: { height: "100%" } } },
                    folder && React.createElement(portal_context_menu_1.PortalContextMenu, { id: tableBodyContextMenuId },
                        portal_context_menu_1.FileItemMenuItem({ Icon: file_table_1.FileItemContextMenuItemTemplates.NewFolder.Icon, Action: createNewFolder, Name: "New Folder" }),
                        this.props.ShowUploadOption && React.createElement(portal_context_menu_1.MenuItem, null,
                            React.createElement(upload_media_component_1.default, { UploadFile: this.props.UploadFile, RaiseInfo: this.props.RaiseInfo, RaiseAlert: this.props.RaiseAlert, ShowIcon: false }))),
                    table));
        }
        else {
            return null;
        }
    }
    *renderBreadCrumb(location) {
        if (location.Type !== resources_1.ResourceTypes.Folder) {
            // A place with no folder of its own has no ancestors to navigate through
            yield React.createElement("ul", { className: "breadcrumbs", key: "breadcrumbs", style: { float: "left" } },
                React.createElement("li", null, location.Name));
            return;
        }
        yield React.createElement("ul", { className: "breadcrumbs", key: "breadcrumbs", style: { float: "left" } }, location.Path.Ancestors
            .map(ancestor => {
            return React.createElement("span", null,
                React.createElement("a", { onClick: () => this.props.Open(ancestor), style: { color: "black", cursor: "pointer" } }, ancestor.Name));
        })
            .map((el, index) => React.createElement("li", { key: index }, el)));
        if (this.state.CreatingNewFolder) {
            const updateName = (event) => this.setState({
                CreatingNewFolder: { Name: event.target.value }
            });
            const createFolder = () => __awaiter(this, void 0, void 0, function* () {
                if (this.state.CreatingNewFolder && this.state.CreatingNewFolder.Name && this.props.CreateFolder) {
                    const path = location.Path.Concat(this.state.CreatingNewFolder.Name);
                    try {
                        const newFolder = yield this.props.CreateFolder(path);
                        this.setState({ CreatingNewFolder: undefined });
                        yield this.props.Open(newFolder);
                    }
                    catch (error) {
                        this.props.RaiseAlert(`${error}`);
                    }
                }
            });
            // Detect div "loss of focus"
            const focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
                if (relatedTarget === null)
                    return false;
                let node = relatedTarget["parentNode"];
                while (node !== null) {
                    if (node === currentTarget)
                        return true;
                    node = node.parentNode;
                }
                return false;
            };
            const onBlur = (event) => {
                if (!focusInCurrentTarget(event)) {
                    this.setState({ CreatingNewFolder: undefined });
                }
            };
            const error = this.getNewFolderError(this.state.CreatingNewFolder.Name);
            const renderTooltip = (props) => {
                let tooltipText = error || "Create new folder";
                return (React.createElement(react_bootstrap_1.Tooltip, Object.assign({}, props), tooltipText));
            };
            yield React.createElement("form", { onSubmit: event => { event.preventDefault(); createFolder(); }, key: "create-folder-input" },
                React.createElement("div", { className: "input-group input-group-sm", onBlur: onBlur, style: { width: "12em" } },
                    React.createElement("input", { type: "text", className: "form-control", value: this.state.CreatingNewFolder.Name, placeholder: "Enter a name", onChange: updateName, autoFocus: true }),
                    React.createElement("div", { className: "input-group-append" },
                        React.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: renderTooltip },
                            React.createElement("button", { className: "btn btn-sm btn-light", type: "button", onClick: createFolder, disabled: !this.state.CreatingNewFolder.Name || !!error }, "Create")))));
        }
    }
    getNewFolderError(name) {
        var _a;
        const currentFolder = resources_1.FolderOf(this.props.Current);
        if (currentFolder) {
            if (currentFolder.Path.Segments.length > maxFolderDepth) {
                return "Sorry, you have reached the maximum folder depth.";
            }
        }
        if (!path_1.Path.IsValidSegment(name)) {
            if (!((_a = this.state.CreatingNewFolder) === null || _a === void 0 ? void 0 : _a.Name)) {
                return "Please enter a name for your folder";
            }
            return `Name contains invalid characters`;
        }
        if (this.props.Resources.some(existingResource => existingResource.Path.Name.toLowerCase() === name.toLowerCase())) {
            return "A file or folder with this name already exists";
        }
    }
}
exports.FileBrowserDisplay = FileBrowserDisplay;
//# sourceMappingURL=file-browser-display.js.map